module.exports = __webpack_public_path__ + "img/5.301fc809.png";